export default {
    setUserInfo({
        commit
    }, user) {
        window.window.sessionStorage.user = JSON.stringify(user);
        commit('setUserInfo', user)
    },

    logOut({
        commit
    }) {
        window.window.sessionStorage.user = "";
        commit('LOGIN_OUT', "")
    }
}